.Accordion,
.AccordionGroup {
    --Accordion--border: 1px solid var(--soniq-t--global--border--color--card--default);

    box-sizing: border-box;
    /* Keeps the header hover fill inside the rounded corners */
    overflow: hidden;
    border: var(--Accordion--border);
    border-radius: var(--soniq-t--global--border--radius--primary--xl);
    background: var(--soniq-t--global--background--color--surface--card);
    font-family: var(--soniq-t--global--font--family--sans);
}

/* Inside a group the card belongs to the group,
   so each accordion is a plain row */
.AccordionGroup > .Accordion {
    border: 0;
    border-radius: 0;
    background: none;

    & + .Accordion {
        border-top: var(--Accordion--border);
    }
}

.Accordion__heading {
    margin: 0;
    font: inherit;
}

.Accordion__header {
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    width: 100%;
    /* Tall enough to press with a finger on a phone */
    min-height: 44px;
    margin: 0;
    padding: 12px 16px;
    border: 0;
    background: none;
    font: inherit;
    text-align: left;
    color: var(--soniq-t--global--text--color--primary--default);
    cursor: pointer;

    &:hover {
        background: var(--soniq-t--global--background--color--surface--hover);
    }

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--palette--hot-pink);
        outline-offset: -2px;
    }

    &:disabled {
        opacity: 0.45;
        cursor: default;
        background: none;
    }
}

.Accordion__headerText {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2px;
    min-width: 0;
}

.Accordion__trailing {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 12px;
}

.Accordion__chevron {
    flex-shrink: 0;

    /* Wins over the size the icon sets on itself */
    &:is(svg) {
        font-size: 18px;
    }
}

.Accordion__panel {
    padding: 12px 16px 16px;
    border-top: var(--Accordion--border);
    background: var(--soniq-t--global--background--color--primary--default);

    /* Wins over any display set on the panel, so a closed panel stays closed */
    &[hidden] {
        display: none;
    }
}

.Accordion__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    margin-bottom: 12px;
}
